var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.426 11.096L4.42601 3.09597C4.25484 3.01499 4.06418 2.98432 3.87625 3.00754C3.68833 3.03076 3.51087 3.10691 3.36456 3.22712C3.21825 3.34734 3.10912 3.50665 3.04989 3.68651C2.99066 3.86636 2.98376 4.05935 3.03001 4.24297L4.96901 12.001L3.03001 19.759C2.98333 19.9427 2.98992 20.1359 3.04902 20.3159C3.10811 20.496 3.21726 20.6555 3.3637 20.7759C3.51014 20.8962 3.68782 20.9723 3.87594 20.9954C4.06406 21.0184 4.25486 20.9874 4.42601 20.906L21.426 12.906C21.5978 12.8252 21.7431 12.6972 21.8448 12.537C21.9466 12.3767 22.0006 12.1908 22.0006 12.001C22.0006 11.8111 21.9466 11.6252 21.8448 11.465C21.7431 11.3047 21.5978 11.1767 21.426 11.096ZM5.48101 18.198L6.32001 14.841L12 12.001L6.32001 9.16097L5.48101 5.80397L18.651 12.001L5.48101 18.198Z",
    fill: "#70808F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxSend);
export default __webpack_public_path__ + "static/media/bx-send.ad8d27f9b5cc45e10ff144803f7daa2a.svg";
export { ForwardRef as ReactComponent };